<template>
  <the-sidebar-layout>
    <div class="show-search-button" v-on:click="showSearch" slot="sidebar-title">{{loc('filterResults')}}</div>
    <div class="hide-mobile sidebarSearch" slot="sidebar">
      <v-form :fields="filterFields" :form-data="formData" :form-errors="formErrors" :on-change="filtersChanged"></v-form>
    </div>
    <div class="hide-mobile" style="float: right; margin-bottom: 50px">
      <div>{{this.loc('records')}}</div>
      <div class="custom-select js-custom-select-wrapper" style="width: 100px">
        <div class="custom-select__dropdown js-custom-select-dropdown custom-select__small">
          <span class="custom-select__text js-custom-select-textholder">{{selectedValue}}</span>
          <select v-model="selected" @change="$refs.table.setLimit($event.target.value)" class="form__field-select js-custom-select form__field-select-custom js-lang-select lang_select">
            <option v-bind:text="10" value="10">10</option>
            <option v-bind:text="25" value="25">25</option>
          </select>
        </div>
      </div>
    </div>
    <v-client-table ref="table" :columns="columns" :data="filteredData" :options="options">
      <router-link slot="serialNumber" slot-scope="props" :to="{ name: 'customer-machine', params: { serialNumber: props.row.serialNumber }}">{{props.row.serialNumber}}</router-link>
      <div slot="deliveryDateWarranty" slot-scope="props">{{props.row.deliveryDateWarrantyFormatted}}</div>
    </v-client-table>
    <div class="spinner"></div>
  </the-sidebar-layout>
</template>

<script>
import VForm from './v-form.vue';
import queryString from 'query-string';
import moment from 'moment';
import $ from 'jquery';

export default {
  name: 'ViewCustomerMachines',
  components: {
    'v-form': VForm
  },
  data: function () {
    return {
      formErrors: {},
      formData: {},
      filterData: {
        serialNumber: '',
        baseModel: '',
        deliveryDateStart: '',
        deliveryDateEnd: '',
        country: '',
        dateAddedStart: '',
        dateAddedEnd: '',
      },
      filteringEnabled: false,
      searchText: '',
      searchColumns: ['machineModelName', 'serialNumber', 'deliveryDateWarrantyFormatted', 'companyName', 'dateAddedFormatted', 'country'],
      columns: ['machineModelName', 'serialNumber', 'deliveryDateWarranty', 'companyName', 'dateAdded', 'country'],
      sortable: ['machineModelName', 'serialNumber', 'deliveryDateWarranty', 'companyName', 'dateAdded','country'],
      filterable: ['machineModelName', 'serialNumber', 'deliveryDateWarranty', 'companyName', 'dateAdded','country'],
      selected: '10'
    }
  },
  computed: {
    filterFields() {
      // Only populate fields after possible url query filters have been applied
      if(!this.filteringEnabled) {
        return [];
      }

      return [{
        name: 'serialNumber',
        value: this.filterData.serialNumber,
        label: this.loc('serialNumber'),
        type: 'text'
      }, {
        name: 'deliveryDateStart',
        value: this.filterData.deliveryDateStart ? new Date(this.filterData.deliveryDateStart) : '',
        label: this.loc('deliveryDateStart'),
        type: 'date'
      }, {
        name: 'deliveryDateEnd',
        value: this.filterData.deliveryDateEnd ? new Date(this.filterData.deliveryDateEnd) : '',
        label: this.loc('deliveryDateEnd'),
        type: 'date'
      }, {
        name: 'baseModel',
        value: this.filterData.baseModel,
        label: this.loc('machineModel'),
        options: this.baseMachineOptions,
        type: 'select'
      }, {
        name: 'country',
        value: this.filterData.country,
        label: this.loc('country'),
        options: this.countryOptions,
        type: 'select'
      }, {
        name: 'dateAddedStart',
        value: this.filterData.dateAddedStart ? new Date(this.filterData.dateAddedStart) : '',
        label: this.loc('dateAddedStart'),
        type: 'date'
      }, {
        name: 'dateAddedEnd',
        value: this.filterData.dateAddedEnd ? new Date(this.filterData.dateAddedEnd) : '',
        label: this.loc('dateAddedEnd'),
        type: 'date'
      }];
    },
    countryOptions() {
      const options = [];
      const addedOptions = [];

      options.push({
        value: '',
        text: '--'
      });

      this.$store.state.customerMachines.forEach(machine => {
        if(addedOptions.indexOf(machine.country.countryCode) === -1) {

          options.push({
            value: machine.country.countryCode,
            text: machine.country.name
          });

          addedOptions.push(machine.country.countryCode);
        }
      });
      options.sort((a, b) => (a.text > b.text) ? 1 : -1);
      return options;
    },
    baseMachineOptions() {
      const options = [];
      const addedOptions = [];

      options.push({
        value: '',
        text: '--'
      });

      this.$store.state.customerMachines.forEach(machine => {
        if( addedOptions.indexOf(machine.machineBaseModelId) === -1 && machine.machineBaseModelName !== null ) {

          if( machine.machineBaseModelId !== null ){
            options.push({
              value: machine.machineBaseModelId,
              text: machine.machineBaseModelName
            });
          }

          addedOptions.push(machine.machineBaseModelId);
        }
      });
      options.sort((a, b) => (a.text > b.text) ? 1 : -1);
      return options;
    },
    machineData() {
      const items = [];

      this.$store.state.customerMachines.forEach(machine => {
        const item = JSON.parse(JSON.stringify(machine));
        item.countryCode = item.country.countryCode;
        item.country = item.country.name;
        item.deliveryDateWarrantyFormatted = item.deliveryDate.formatted;
        item.deliveryDateWarranty = item.deliveryDate.date;
        item.dateAddedFormatted =  item.dateAdded.formatted;
        item.dateAdded = item.dateAdded.date;
        item.companyName = (item.retail_customer_name != '') ? item.retail_customer_name : item.companyName;
        items.push(item);
      });

      return items;
    },
    options() {
      return {
        filterable: false,
        headings: {
          machineModelName: this.loc('machineModel'),
          serialNumber: this.loc('serialNumber'),
          deliveryDateWarranty: this.loc('customerMachineWarrantyRegistered'),
          companyName: this.loc('company'),
          country: this.loc('country'),
          dateAdded: this.loc('dateAddedMachine')
        },
        texts: {
            count: this.loc('paginationCount'),
            limit: this.loc('records'),
            noResults: this.loc('noMatchingResults'),
        },
        skin: 'table-responsive'

      }
    },
    filteredData() {
      const self = this;
      const searchText = this.$store.state.subheader.searchText; // Use subheader search input for searching
      const data = this.machineData;
      const filterData = this.filterData;

      return data.filter(item => {
        for(let key in this.filterData) {
          switch(key) {
            case 'serialNumber':
              if(this.filterData.serialNumber) {
                const searchRegEx = new RegExp(this.filterData.serialNumber, 'i');

                // If serialnumber search doesn't match, exclude from list
                if(!searchRegEx.test(item.serialNumber)) {
                  return false;
                }
              }
            break;
            case 'deliveryDateStart':
              if(this.filterData.deliveryDateStart) {
                // If deliverydate is bigger than filtered end date, exclude
                if(!item.deliveryDateWarranty || (this.filterData.deliveryDateStart && item.deliveryDateWarranty< this.filterData.deliveryDateStart)) {
                  return false;
                }
              }
            break;
            case 'deliveryDateEnd':
              if(this.filterData.deliveryDateEnd) {
                // If deliverydate is bigger than filtered end date, exclude
                if( !item.deliveryDateWarranty || (this.filterData.deliveryDateEnd && item.deliveryDateWarranty > this.filterData.deliveryDateEnd) ) {
                  return false;
                }
              }
            break;
            case 'dateAddedStart':
              if(this.filterData.dateAddedStart) {
                // If deliverydate is bigger than filtered end date, exclude
                if(!item.dateAdded || (this.filterData.dateAddedStart && item.dateAdded < this.filterData.dateAddedStart)) {
                  return false;
                }
              }
            break;
            case 'dateAddedEnd':
              if(this.filterData.dateAddedEnd) {
                // If deliverydate is bigger than filtered end date, exclude
                if(!item.dateAdded || (this.filterData.dateAddedEnd && item.dateAdded > this.filterData.dateAddedEnd)) {
                  return false;
                }
              }
            break;
            case 'baseModel':
              // If baseModel is selected, exclude other base model machines
              if(this.filterData.baseModel && item.machineBaseModelId !== this.filterData.baseModel) {
                return false;
              }
            break;
            case 'country':
              // If country is selected, exclude other countries
              if(this.filterData.country && item.countryCode !== this.filterData.country) {
                return false;
              }
            break;
          }
        }

        // If we made it this far, add to list
        return true;
      });

    },
    selectedValue() {
      return this.selected;
    }
  },
  methods: {
    // Format data for filters
    filtersChanged(data) {
      const dateFormat = 'Y-MM-DD';
      const filterData = {
        serialNumber: data.serialNumber,
        baseModel: !data.baseModel ? '' : data.baseModel,
        country: !data.country ? '' : data.country,
        deliveryDateStart: '',
        deliveryDateEnd: '',
        dateAddedStart: '',
        dateAddedEnd: ''
      };

      if(data.deliveryDateStart) {
        const date = moment(data.deliveryDateStart).format(dateFormat);
        filterData.deliveryDateStart = date;
      } else {
        filterData.deliveryDateStart = '';
      }

      if(data.deliveryDateEnd) {
        const date = moment(data.deliveryDateEnd).format(dateFormat);
        filterData.deliveryDateEnd = date;
      } else {
        filterData.deliveryDateEnd = '';
      }

      if(data.dateAddedStart) {
        const date = moment(data.dateAddedStart).format(dateFormat);
        filterData.dateAddedStart = date;
      } else {
        filterData.dateAddedStart = '';
      }

      if(data.dateAddedEnd) {
        const date = moment(data.dateAddedEnd).format(dateFormat);
        filterData.dateAddedEnd = date;
      } else {
        filterData.dateAddedEnd = '';
      }

      this.updateFilterData(filterData);
      this.updateUrl();
      this.$refs.table.setPage(1);

    },
    updateFilterData(data) {
      Object.keys(data).forEach(key => {
        this.filterData[key] = data[key];
      });
    },
    updateUrl() {
      const activeFilters = {};

      // Only include filters with values
      Object.keys(this.filterData).forEach(key => {
        const value = this.filterData[key];
        if(value !== '') {
          activeFilters[key] = value;
        }
      });

      if(this.filteringEnabled) {
        if(Object.keys(activeFilters).length) {
          this.$router.replace({query: { filters: queryString.stringify(activeFilters) }});
        } else {
          //.catch error emptying is due vue-router core changes.
          // prevents faulty error "NavigationDuplicated Navigating to current location (“/“) is not allowed"
          // See -> https://stackoverflow.com/questions/57837758/navigationduplicated-navigating-to-current-location-search-is-not-allowed
          this.$router.replace({query: {}}).catch(err => {});
        };

      }
    },
    showSearch(){
      $('.sidebarSearch').toggleClass('show-search');
    }
  },
  mounted: function () {
    // Check if we're loading this view with active filters
    const filtersSerialized = this.$route.query.filters;

    if(filtersSerialized) {
      const filters = queryString.parse(filtersSerialized);
      if(filters) {
        this.updateFilterData(filters);
      }
    }

    this.filteringEnabled = true;

    this.$store.dispatch('getCustomerMachines', this.$store.state.user.company.id)
      .then(() => {
          $('.spinner').hide();
      });


    this.$store.commit('setSubheader', {
      subtitle: '',
      title: this.loc('components.customerMachines.subheaderTitle'),
      description: this.loc('components.customerMachines.subheaderDescription'),
      searchEnabled: false
    });

    if($(window).width() <= 768){
      $('.show-search-button')
      .closest('.order-1')
      .addClass('search-button-parent-mobile');
    }

    $( window ).resize(function() {
      if($(window).width() <= 768){
        $('.show-search-button')
        .closest('.order-1')
        .addClass('search-button-parent-mobile');
      } else {
        $('.show-search-button')
        .closest('.order-1')
        .removeClass('search-button-parent-mobile');
        }
    });
  }
}
</script>
